import { render, staticRenderFns } from "./bibliometric.vue?vue&type=template&id=2184bb2a&scoped=true"
import script from "./bibliometric.vue?vue&type=script&lang=js"
export * from "./bibliometric.vue?vue&type=script&lang=js"
import style0 from "./bibliometric.vue?vue&type=style&index=0&id=2184bb2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184bb2a",
  null
  
)

export default component.exports